export const tryParseJSON = (jsonString: string) => {
  try {
    const o = JSON.parse(jsonString);
    if (o) {
      return o;
    }
    return undefined;
  } catch {
    return undefined;
  }
};
